import React, { useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import configtreejson from "../Tempdata/ConfigTreejson";
import { setTemplateState, updateconfigtabpath } from "../store/cofig_data";
import General from "./ConfigPages/General";
import SystemSetup from "./ConfigPages/SystemSetup";
import OrganisationSetting from "./ConfigPages/OrganisationSetting";
import ComplianceConfiguration from "./ConfigPages/ComplianceConfiguration";
import EnergyAnalyticsConfiguration from "./ConfigPages/EnergyAnalyticsConfiguration";
import PowerQualityConfiguration from "./ConfigPages/PowerQualityConfiguration";
import EnergyAccountingConfiguration from "./ConfigPages/EnergyAccountingConfiguration";
import Gateways from "./ConfigPages/Gateways";
import Devices from "./ConfigPages/Devices";
import Assets from "./ConfigPages/Assets";
import Notification from "./ConfigPages/Notification";
import UserManagement from "./ConfigPages/UserManagement";
import TemplateGroup from "./Reports/TemplateGroup";
import Template from "./Reports/Template";
import TemplateConfigurator from "./Reports/TemplateConfigurator";
import Plantviewcreationpage from "./ConfigPages/Plantviewcreationpage";
import Dashboardlist from "./ConfigPages/Dashboardconfig/Dashboardlist";
import AlertConfiguration from "./ConfigPages/Alertsconfig/AlertConfiguration";
import AlertGeneralConfiguration from "./ConfigPages/Alertsconfig/AlertGeneralConfiguration";
import Auditlog from "./ConfigPages/AuditLog";
import Map from "./ConfigPages/Map";
import PeriodicMaintenanceSchedule from "./ConfigPages/PeriodicMaintenanceSchedule";
import PeriodicMaintenanceConfigurationParameters from "./ConfigPages/PeriodicMaintenanceConfigurationParameters";
import ProtectedComponent from "./ConfigPages/UserAccessManangement/ProtectedComponent";
import DbrdConfiguration from "./ConfigPages/DashboardConfigurator/Dashboard/DashboardList";
import DeviceTypes from "./ConfigPages/DeviceTypes";
import StatusTable from "./ConfigPages/StatusTable";
import OverviewHomePage from "./ConfigPages/OverviewHomePage";
import GroupConfiguration from "./ConfigPages/GroupConfiguration";
import OverviewConfig from "./ConfigPages/OverviewConfig";
import DeviceLibrary from "./ConfigPages/DeviceLibrary";
import Storage from "./ConfigPages/Storage";
import StoragePeriod from "./ConfigPages/StoragePeriod";
import AuditConfig from "./ConfigPages/AuditConfig";
import CommissionIntegration from "./ConfigPages/CommissionIntegration";
import Elogbook from "./ConfigPages/Elogbook";
import Scheduler from "./Reports/Scheduler";

const components = {
  General: General,
  AlertConfiguration: AlertConfiguration,
  AlertGeneralConfiguration: AlertGeneralConfiguration,
  TemplateGroup: TemplateGroup,
  Template: Template,
  TemplateConfigurator: TemplateConfigurator,
  Scheduler: Scheduler,
  SystemSetup: SystemSetup,
  OrganisationSetting: OrganisationSetting,
  ComplianceConfiguration: ComplianceConfiguration,
  EnergyAnalyticsConfiguration: EnergyAnalyticsConfiguration,
  EnergyAccountingConfiguration: EnergyAccountingConfiguration,
  PowerQualityConfiguration: PowerQualityConfiguration,
  Gateways: Gateways,
  Devices: Devices,
  DeviceLibrary: DeviceLibrary,
  DeviceTypes: DeviceTypes,
  Assets: Assets,
  Storage: Storage,
  StoragePeriod: StoragePeriod,
  Notification: Notification,
  UserManagement: UserManagement,
  Plantviewcreation: Plantviewcreationpage,
  Dashboardcreation: Dashboardlist,
  Auditlog: Auditlog,
  Map: Map,
  Auditlog: Auditlog,
  PeriodicMaintenanceSchedule: PeriodicMaintenanceSchedule,
  PeriodicMaintenanceConfigurationParameters:
    PeriodicMaintenanceConfigurationParameters,
  OverviewConfig: OverviewConfig,
  StatusTable: StatusTable,
  OverviewHomePage: OverviewHomePage,
  GroupConfiguration: GroupConfiguration,
  AuditConfig: AuditConfig,
  CommissionIntegration:CommissionIntegration,
  DbrdConfiguration: DbrdConfiguration,
  Elogbook: Elogbook,
};

const permissionMap = {
  General: "PJGC23",
  AlertConfiguration: "PJNC36",
  AlertGeneralConfiguration: "PJNC36",
  TemplateGroup: "PRTC59",
  Template: "PRTC59",
  TemplateConfigurator: "PRTC59",
  Scheduler: "PRTC59",
  SystemSetup: "SYSTEM_SETUP",
  OrganisationSetting: "ORGANIZATION_CONFIG",
  ComplianceConfiguration: "PESC49",
  EnergyAnalyticsConfiguration: "PEAC39",
  EnergyAccountingConfiguration: "PECC41",
  PowerQualityConfiguration: "PPQC43",
  Gateways: "PJGF26",
  Devices: "PJDF29",
  DeviceTypes: "PJDF29",
  DeviceLibrary: "PJDL30",
  Assets: "PJAF32",
  Storage: "PSTC80",
  StoragePeriod: "PSTC80",
  Notification: "PJNC36",
  UserManagement: "USER_MANAGEMENT",
  Plantviewcreation: "PJPC24",
  Dashboardcreation: "PJDW18",
  DbrdConfiguration: "PJDW18",
  Auditlog: "PAUV72",
  Map: "PJMP34",
  PeriodicMaintenanceSchedule: "PMAC47",
  PeriodicMaintenanceConfigurationParameters: "PMAC47",
  StatusTable: "PSTC45",
  OverviewHomePage: "PJOB37",
  GroupConfiguration: "PJNC36",
  OverviewConfig: "PJOB37",
  AuditConfig: "PAUC71",
  Elogbook: "PRTC59",
  CommissionIntegration: "PAUC71",
};

function ConfigTab({ componentName, userPermissions }) {
  if (componentName !== "OrganisationSetting") {
    const ComponentToRender = components[componentName];
    const requiredPermission = permissionMap[componentName];
    return ComponentToRender && requiredPermission ? (
      <ProtectedComponent
        permission={requiredPermission}
        userPermissions={userPermissions}
      >
        <ComponentToRender />
      </ProtectedComponent>
    ) : null;
  }
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ borderRadius: "0px" }}
    >
      {value === index && (
        <Box sx={{ p: 0, borderRadius: "0px" }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default function ConfigMainPage(props) {
  const dispatch = useDispatch();
  const { PermissionsArray: usrPrmns } = useSelector(
    (state) => state.logindata.userdetails,
  );
  const tabpath = useSelector(
    (state) => state.configdata.selectedconfigtabpath,
  );
  const selectedtreepath = useSelector(
    (state) => state.configdata.configtreepathselected,
  );
  const overviewstate = useSelector(
    (state) => state.mainpagedata.overviewbarstate,
  );
  const [value, setValue] = React.useState();
  const [mainpath, setMainpath] = useState([]);
  const [pagesize, setPagesize] = useState(270);
  const [filteredChildren, setFilteredChildren] = useState([]);

  const selectedTab = useSelector((state) => state.configdata.selectedTab);
  const templateState = useSelector((state) => state.configdata.templateState);

  // Filter children based on permissions whenever selectedtreepath changes

  useEffect(() => {
    const selectedItem = configtreejson.find(
      (item) => item.label === selectedtreepath[0],
    );
    if (selectedItem && selectedItem.child.length > 0) {
      const filtered = selectedItem.child.filter((it) => {
        const requiredPermission = permissionMap[it.pagename];

        // Security: If no permission defined, hide by default
        if (!requiredPermission) {
          console.warn(` No permission defined for: ${it.pagename}`);
          return false;
        }

        // Ensure usrPrmns is an array and check permission
        if (
          !Array.isArray(usrPrmns) ||
          !usrPrmns.includes(requiredPermission)
        ) {
          return false;
        }

        return true;
      });
      setFilteredChildren(filtered);
    } else {
      setFilteredChildren([]);
    }
  }, [selectedtreepath, usrPrmns]);

  const handleChange = (event, newValue) => {
    if (templateState.state === 1 || templateState.state === 2) {
      dispatch(setTemplateState({ state: 0, id: "", name: "" }));
    }
    setValue(newValue);
  };

  useEffect(() => {
    setValue(selectedTab.value);
    setMainpath([selectedTab.tab]);
  }, [selectedTab]);

  // useEffect(() => {
  //   if (selectedtreepath[0] === "Alert") {
  //     if (value === 0) {
  //       setMainpath(["Alert Configuration"]);
  //     } else if (value === 1) {
  //       setMainpath(["Alert General Configuration"]);
  //     }
  //   } else if (selectedtreepath[0] === "Group") {
  //     if (value === 0) {
  //       setMainpath(["Group Configuration"]);
  //     }
  //   } else if (selectedtreepath[0] === "Report") {
  //     if (value === 0) {
  //       setMainpath(["Template Group"]);
  //     } else if (value === 1) {
  //       setMainpath(["Template"]);
  //     } else if (value === 2) {
  //       setMainpath(["Configuration"]);
  //     }
  //   } else if (selectedtreepath[0] === "Modules") {
  //     if (value === 5) {
  //       setMainpath(["Compliance"]);
  //     } else if (value === 0) {
  //       setMainpath(["Energy Analytics"]);
  //     } else if (value === 1) {
  //       setMainpath(["Energy Accounting"]);
  //     } else if (value === 2) {
  //       setMainpath(["Power Quality"]);
  //     } else if (value == 3) {
  //       setMainpath(["Periodic Maintenance Configuration Parameters"]);
  //     } else if (value == 4) {
  //       setMainpath(["Periodic Maintenance Schedule"]);
  //     } else if (value == 6) {
  //       setMainpath(["Status Table"]);
  //     }else if (value == 7) {
  //       setMainpath(["Overview"]);
  //     }
  //   } else if (selectedtreepath[0] === "Gateway") {
  //     if (value === 0) {
  //       setMainpath(["Gateway"]);
  //     }
  //   } else if (selectedtreepath[0] === "Device") {
  //     if (value === 0) {
  //       setMainpath(["Device"]);
  //     } else if (value === 1) {
  //       setMainpath(["Device Library"]);
  //     } else if (value === 2) {
  //       setMainpath(["Device Types"]);
  //     }
  //   } else if (selectedtreepath[0] === "Storage") {
  //     if (value === 0) {
  //       setMainpath(["Storage Groups"]);
  //     } else if (value === 1) {
  //       setMainpath(["Storage Period"]);
  //     }
  //   } else {
  //     setMainpath([]);
  //   }
  // }, [value, selectedtreepath]);

  useEffect(() => {
    // Map value to the correct component based on filtered children
    if (
      filteredChildren.length > 0 &&
      value !== undefined &&
      value < filteredChildren.length
    ) {
      setMainpath([filteredChildren[value].label]);
    } else if (selectedtreepath[0]) {
      const selectedItem = configtreejson.find(
        (item) => item.label === selectedtreepath[0],
      );
      if (selectedItem && selectedItem.child.length === 0) {
        setMainpath([selectedItem.label]);
      }
    } else {
      setMainpath([]);
    }
  }, [value, selectedtreepath, filteredChildren]);

  useEffect(() => {
    setValue(0);
  }, [selectedtreepath]);

  useEffect(() => {
    dispatch(updateconfigtabpath(mainpath));
  }, [mainpath]);

  useEffect(() => {
    if (overviewstate) {
      setPagesize(295);
    } else {
      setPagesize(260);
    }
  }, [overviewstate]);

  return (
    <Box
      sx={{
        width: "88.5%",
        backgroundColor: "var(--SecondaryBackground)",
        borderRadius: "0px 0px 0px 0px",
        marginRight: "0px",
      }}
    >
      <Box sx={{ backgroundColor: "var(--PrimaryBackground)" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{
            width: "auto",
            "& .MuiTabs-indicator": { display: "none" },
            "& .Mui-selected": {
              backgroundColor: "var(--SecondaryBackground)",
              borderRadius: "0px 0px 0px 0px",
              color: "var(--LK_BrandBlue_1) !important",
              fontWeight: "700 !important",
              borderTop: "1px solid var(--HighlightedText_Stroke)",
              borderLeft: "1px solid var(--HighlightedText_Stroke)",
              borderRight: "1px solid var(--HighlightedText_Stroke)",
              borderBottom: "1px solid var(--SecondaryBackground)",
            },
            "& .MuiTab-root": {
              padding: "8px 8px 6px 8px !important",
              margin: "0px !important",
              minWidth: "63px",
            },
            minHeight: "30px",
            marginBottom: "-1px",
          }}
        >
          {configtreejson.map((item) =>
            selectedtreepath[0] === item.label ? (
              item.child.length === 0 ? (
                <Tab
                  label={item.label}
                  sx={{ minHeight: "30px", height: "30px" }}
                  style={{
                    color: "var(--GreyVariation_2)",
                    fontFamily: "Roboto",
                    fontSize: "14px",
                    fontWeight: 400,
                    lineHeight: "16.41px",
                    textTransform: "capitalize",
                    flexGrow: 0,
                  }}
                />
              ) : (
                /* item.child.map(..) --> filteredChildren.map(..)*/
                filteredChildren.map((it) => (
                  <Tab
                    key={it.id}
                    label={it.label}
                    sx={{ minHeight: "30px", height: "30px" }}
                    style={{
                      color: "var(--GreyVariation_2)",
                      fontFamily: "Roboto",
                      fontSize: "14px",
                      fontWeight: 400,
                      lineHeight: "16.41px",
                      textTransform: "capitalize",
                      flexGrow: 0,
                    }}
                  />
                ))
              )
            ) : null,
          )}
        </Tabs>
      </Box>
      <Box
        sx={{
          width: "100%",
          border: "1px solid var(--HighlightedText_Stroke)",
          height: `calc(100vh - ${pagesize}px)`,
        }}
        //  style={{ overflow: ((selectedtreepath[0] === 'Dashboardcreation') || (selectedtreepath[0] === 'DbrdConfiguration')) ? 'auto' : 'visible' }}
        style={{ overflow: "auto" }}
      >
        {configtreejson.map((item) =>
          selectedtreepath[0] === item.label ? (
            item.child.length === 0 ? (
              <ConfigTab
                componentName={item.pagename}
                userPermissions={usrPrmns}
              />
            ) : (
              /* item.child.map(..) --> filteredChildren.map(..)*/
              filteredChildren.map((it, index) =>
                value === index ? (
                  <ConfigTab
                    key={it.id}
                    componentName={it.pagename}
                    userPermissions={usrPrmns}
                  />
                ) : null,
              )
            )
          ) : null,
        )}
      </Box>
    </Box>
  );
}
